import Head from 'next/head';
import { Header } from '../../components';
import previewMain from '../../public/preview/preview-main.png';

import MVP from './mvp';

const menu = [
  {
    id: 1,
    href: '/',
    label: 'Home',
  },
  {
    id: 2,
    href: '#process',
    label: 'Process',
  },
  {
    id: 3,
    href: '#why-us',
    label: 'Why Us',
  },
  {
    id: 4,
    href: '#works',
    label: 'Works',
  },
];

function NFTPage(): JSX.Element {
  return (
    <>
      <Head>
        <title>Build Your MVP in 6 Weeks | iOS, Android & Web by MAVINX</title>
        <meta
          property="og:title"
          content="Build Your MVP in 6 Weeks | iOS, Android & Web by MAVINX"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Build Your MVP in 6 Weeks | iOS, Android & Web by MAVINX"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Launch fast with a clean, native MVP in 6 weeks. iOS, Android, Web. From $7k. Weekly demos. Built in Europe by MAVINX — startup-focused dev team."
        />
        <meta
          name="description"
          content="Launch fast with a clean, native MVP in 6 weeks. iOS, Android, Web. From $7k. Weekly demos. Built in Europe by MAVINX — startup-focused dev team."
        />
        <meta
          name="keywords"
          content="MVP development, build MVP fast, MVP in 6 weeks, startup MVP, native app development, MVP agency, Swift Kotlin Laravel React, Europe developers, MVP development, build MVP fast, MVP in 6 weeks, launch MVP startup, native mobile app development, iOS Android MVP, Swift Kotlin Laravel React, hire MVP developers Europe, MVP pricing from $7k, fixed timeline MVP, startup product launch, startup tech partner, early-stage startup development, founder app idea, startup prototype, MVP web app, React JS MVP, Next.js development, Laravel backend MVP, mobile app agency Europe, build app Poland, MVP agency for startups, startup development team, build SaaS MVP, pre-seed MVP, tech for founders"
        />
      </Head>
      <Header
        appearance="transparent"
        contactLink="#contact"
        appearanceLogo="primary"
        menu={menu}
      />
      <MVP />
    </>
  );
}

export default NFTPage;
